<script>
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import { Helper } from '@/mixin/helper'
import {
  GET_PART_CATEGORIES,
  GET_PART_CATEGORY_BY_ID,
  CREATE_PART_CATEGORY,
  UPDATE_PART_CATEGORY,
  DELETE_PART_CATEGORY,
} from '@/services/api/setting/maintenance/parts/categories'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },

  computed: {
    fields() {
      return [
        {
          key: 'category',
          label: this.$t('setting.list.maintenance.partsCategory'),
          placeholder: this.$t('setting.list.maintenance.partsCategory'),
          thClass: 'mc-table--50',
          isSortable: false,
          editable: true,
          validation: [['required', 'trim']],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_PART_CATEGORIES,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const data = res.data.partCategories.partCategories.data
          this.$store.commit('setting/SET_PARTS', data)

          return res.data.partCategories.partCategories
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: CREATE_PART_CATEGORY,
            fetchPolicy: 'no-cache',
            variables: {
              input: data,
            },
          })

          if (!res.data.createPartCategory.isSuccessful) {
            if (res.data.createPartCategory.errorName === 'PartCategoryAlreadyExist')
              this.$mcToast.error(
                this.$t('setting.list.maintenance.alert.' + res.data.createPartCategory.errorName)
              )
            return false
          } else {
            const newData = await this.$apollo.query({
              query: GET_PART_CATEGORY_BY_ID,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  partCategoryId: res.data.createPartCategory.createPartCategory.partCategoryId,
                },
              },
            })

            return newData.data.partCategory.partCategory
          }
        },
        update: async (id, oldData, newData) => {
          const input = {
            partCategoryId: id,
            oldData: {
              category: oldData.category,
            },
            newData: {
              category: newData.category,
            },
          }

          const res = await this.$apollo.mutate({
            mutation: UPDATE_PART_CATEGORY,
            fetchPolicy: 'no-cache',
            variables: {
              input: input,
            },
          })

          if (!res.data.updatePartCategory.isSuccessful) {
            if (res.data.updatePartCategory.errorName === 'PartCategoryAlreadyExist')
              this.$mcToast.error(
                this.$t('setting.list.maintenance.alert.' + res.data.updatePartCategory.errorName)
              )
            else {
              this.$mcToast.error({
                component: 'McToastDynamicBody',
                props: {
                  contents: [
                    {
                      tag: 'h6',
                      text: this.$t('maintenance.alert.editFailed'),
                    },
                    {
                      tag: 'p',
                      text: this.$t(`global.alert.text.failedEdit`),
                    },
                  ],
                },
              })
            }
            return false
          }

          if (!res.data.updatePartCategory.updatePartCategory) return true
          return res.data.updatePartCategory.updatePartCategory
        },
        delete: async (id) => {
          const input = {
            partCategoryId: +id,
          }

          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: DELETE_PART_CATEGORY,
            variables: {
              input: input,
            },
          })

          return res.data.deletePartCategory.isSuccessful
        },
      }
    },
  },

  mounted() {
    this.$store.commit('setting/SET_DATA', this.data)
  },

  methods: {
    handleClick() {
      this.$router.push({ name: 'Log Maintenance Setting', params: { type: 'category' } })
    },

    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t(`setting.list.maintenance.alert.ResourceBeingUsed`),
            },
          ],
        },
      })
    },
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0 pb-4" @click="$store.commit('setting/SET_STATUS', status)">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('setting.list.maintenance.partsCategory') }}</span>
    </template>

    <!-- Table -->
    <McGraphqlEditableTable
      ref="partCatRef"
      :fields="fields"
      :apiClient="query"
      trackBy="partCategoryId"
      :searchable="true"
      :customToast="customToast"
    />
  </b-tab>
</template>
